import { useCallback, useMemo } from 'react'
import { useHistory, useParams, useLocation } from 'react-router-dom'
import { isNumber } from 'lodash'
import queryString from 'query-string'

import concepts from 'data/output/concept-nodes.json'
import lmTree from 'data/output/lm-tree.json'
import lmToConceptDict from 'data/output/lm-to-concept-dict.json'

const options = { arrayFormat: 'bracket' }

export const nodeIdToIndex = concepts.reduce((p, c, i) => {
  p[c.id] = i
  return p
}, {})

export function useCurrentNode () {
  const { nodeId } = useParams()
  const { search } = useLocation()
  const history = useHistory()
  if (nodeId && (lmToConceptDict[nodeId] || isNumber(nodeIdToIndex[nodeId]))) {
    return nodeId
  } else {
    history.push(`/${lmTree.id}${search}`)
    return lmTree.id
  }
}

export const useCurrentNodeIsRoot = () => {
  const nodeId = useCurrentNode()
  return nodeId === lmTree.id
}

export function useQueryParams () {
  const { search } = useLocation()

  const value = useMemo(() => {
    return queryString.parse(search, options)
  }, [search])

  return value
}

export function useChangeHistory () {
  const params = useQueryParams()
  const history = useHistory()

  const action = useCallback(
    (value) => {
      const stringified = queryString.stringify({
        ...params,
        ...value
      }, options)
      history.push(`?${stringified}`)
    },
    [params, history]
  )

  return action
}
